import { useState } from "react";
import { Link } from "react-router-dom";
import { LogIn } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

const LoginPage = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Acesso liberado");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao entrar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F2EB] flex items-center justify-center p-6">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-sm border border-[#E2E8F0]">
        <h1 className="font-serif text-3xl text-center mb-2">PERYTUS</h1>
        <p className="text-center text-[#718096] mb-6">Entre em sua conta</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Senha</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <div className="text-right text-sm">
            <button type="button" onClick={() => toast.info("Entre em contato: suporte@perytus.com.br")} className="text-[#0F4C5C] hover:underline">
              Esqueci minha senha
            </button>
          </div>
          <Button type="submit" className="w-full">
            <span className="flex items-center gap-2"><LogIn size={18} /> {loading ? "Entrando..." : "Entrar"}</span>
          </Button>
        </form>
        <p className="text-center mt-6 text-sm text-[#718096]">
          Ainda não tem conta? <Link to="/register" className="text-[#0F4C5C] hover:underline">Cadastre-se</Link>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
